import React from 'react'
import {Field, reduxForm} from 'redux-form'
import {connect} from 'react-redux'

let PersonaForm = props => {
  const {handleSubmit, cancel, submitting} = props;

  return (
    <form onSubmit={handleSubmit}>
      <div className="modal-body">
        <div className="form-group">
          <label htmlFor="firstName">First Name</label>
          <Field className="form-control" name="firstName" component="input" type="text"/>
        </div>
        <div className="form-group">
          <label htmlFor="lastName">Last Name</label>
          <Field className="form-control" name="lastName" component="input" type="text"/>
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <Field className="form-control" name="phone" component="input" type="text"/>
        </div>
        <div className="form-group">
          <label htmlFor="phone">Mobile</label>
          <Field className="form-control" name="mobile" component="input" type="text"/>
        </div>
        <div className="form-group">
          <label htmlFor="phone">Fax</label>
          <Field className="form-control" name="fax" component="input" type="text"/>
        </div>
        <div className="form-group">
          <label htmlFor="phone">Birthday</label>
          <Field className="form-control" name="birthday" component="input" type="text"/>
        </div>
        <div className="form-group">
          <label htmlFor="phone">Gender</label>
          <Field className="form-control" name="gender" component="input" type="text"/>
        </div>
        <div className="form-group">
          <label htmlFor="phone">Title</label>
          <Field className="form-control" name="title" component="input" type="text"/>
        </div>
      </div>
      <div className="modal-footer">
        <button type="submit" className="btn btn-primary col-xs-4 m-l pull-right" disabled={submitting}>
          <span className="btn-text">Create a persona</span>
        </button>
        <button type="button" className="btn btn-default col-xs-4 pull-right" onClick={cancel}>
          <span className="btn-text">Cancel</span>
        </button>
      </div>
    </form>
  )
};

PersonaForm = reduxForm({
  form: 'persona'
})(PersonaForm);

PersonaForm = connect(
  state => {
    const initialValues = {
      firstName: 'Max',
      lastName: 'Maxx',
      phone: '00493012346',
      mobile: '00493012345',
      fax: '00493012345',
      birthday: 358293600000,
      gender: 'MALE',
      title: 'Prof. Dr.'
    };

    return {
      initialValues
    };
  }
)(PersonaForm);

export default PersonaForm;



// WEBPACK FOOTER //
// ./src/order/subforms/customer/PersonaForm.js